<template>
    <transition appear name="fade-transition">
        <div :class="classList">
            <v-file-input
                ref="input"
                v-model="inputValue"
                v-test-id
                class="edit__file__input"
                :name="name || uuid"
                outlined
                dense
                :rules="validators"
                :label="label"
                :hint="hint"
                :description="description"
                background-color="background"
                color="primaryText"
                :hide-details="hideDetails || (!form && _.isEmpty(validators))"
                :disabled="disabled"
                :loading="loading"
                :readonly="readonly"
                :autocomplete="autocomplete ? 'on' : 'off'"
                :error-messages="errorMessages"
                :multiple="multiple"
                :counter="counter"
                :prepend-icon="null"
                :accept="accept"
                @focus="$emit('focus', inputValue)"
                @blur="$emit('blur', inputValue)"
                @keyup="$emit('keyup', inputValue)"
                @keydown="$emit('keydown', inputValue)"
                @click="$emit('click', inputValue)"
            >
                <template #progress>
                    <slot name="progress" />
                </template>
                <template #selection="data">
                    <slot name="selection" v-bind="data" />
                </template>
            </v-file-input>
        </div>
    </transition>
</template>

<script>
import Edit from './Edit';

export default {
    name: 'EditFile',
    extends: Edit,
    props: {
        multiple: {
            type: Boolean,
            default: false
        },
        counter: {
            type: Boolean,
            default: false
        },
        showSize: {
            type: Boolean,
            default: true
        },
        accept: {
            type: String,
            default: null
        }
    }
};
</script>

<style lang="scss">
.edit__file {
    min-width: 10rem;
    .v-input__prepend-outer {
        align-self: flex-start !important;
        padding-top: 0.95rem;
    }
}
</style>
